import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  FormControl,
  Alert
} from 'react-bootstrap';
import { find, prop, equals, head } from 'ramda';
import questionTypes from './questionTypes.json';

RangeQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  help: PropTypes.string,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string
};

const answerId = prop("answerId");
const findAnswerForOption = option =>
  find(answer => equals(answerId(option), answerId(answer)));

export function RangeQuestion({
  questionId,
  text,
  help,
  unit,
  options,
  answers,
  onAnswer,
  readOnly,
  showValidation,
  validationState = null
}) {
  let answer;
  let option;
  if (answers.length === 1) {
    answer = head(answers);
    options.forEach(currentOption => {
      if (answerId(currentOption) === answerId(answer)) {
        option = currentOption;
      }
    })
  } else {
    option = head(options);
    answer = findAnswerForOption(option)(answers);
  }
  if (readOnly && answer.answeredByEngineVariable) {
    return null;
  }
  const value = answer ? answer.value : '';
  if (!option) {
    option = {};
    option.answerId = option ? option.answerId : '';
  }

  return <FormGroup className='col-md-3 input-form-group' controlId={questionId} validationState={validationState}>
    <ControlLabel>{text}</ControlLabel>
    <FormControl
      type='number'
      disabled={readOnly}
      value={value}
      onChange={(event) => onAnswer(questionId, questionTypes.range, option.answerId, event.target.value,
        {
          displayValue: { text: event.target.value }
        })}/>
    {help && showValidation && <HelpBlock>
      <Alert bsStyle='danger'>
        {help}
      </Alert>
    </HelpBlock>}
  </FormGroup>
}



// WEBPACK FOOTER //
// ./src/components/questions/RangeQuestion.js